import { state as init } from "../../GlobalState";
import * as actions from "./actions";

const reducer = (state = init, action) => {
  switch (action.type) {
    case actions.GET_CATEGORIES: {
      return { ...state, loading: true, error: "" };
    }
    case actions.GET_SINGLE_CATEGORY: {
      return { ...state, loading: true, error: "" };
    }
    case actions.GET_CATEGORIES_FAILURE: {
      return { ...state, loading: false, error: action.payload };
    }
    case actions.GET_CATEGORIES_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: "",
        categories: action.payload?.categories,
      };
    }

    case actions.UPDATE_MONITOR_REFLECTED_INDEXES: {
      return {
        ...state,
        progress_monitor_reflected_indexes: action.payload,
      };
    }

    case actions.CREATE_PROGRESS_MONITOR: {
      return {
        ...state,
        progress_monitor_bool: true,
      };
    }

    case actions.GET_PROGRESS_MONITOR: {
      return {
        ...state,
        // progress_monitor_bool: true,
      };
    }

    case actions.SET_MONITOR_ID: {
      return {
        ...state,
        monitor_id: action.payload,
      };
    }

    case actions.GET_PROGRESS_MONITOR_COMPLETE: {
      return {
        ...state,
        progress_monitor_bool: true,
        monitor_max_progress:
          action.payload.progress_monitoring_record.max_progress,
        monitor_current_progress:
          action.payload.progress_monitoring_record.current_progress,
      };
    }

    case actions.GET_PROGRESS_MONITOR_CLOSE: {
      return {
        ...state,
        monitor_id: null,
        progress_monitor_bool: false,
        monitor_max_progress: 0,
        monitor_current_progress: 0,
      };
    }

    // case actions.ADD_CATEGORY: {
    //   return { ...state, loading: true, error: "" };
    // }
    // case actions.ADD_CATEGORY_FAILURE: {
    //   return { ...state, loading: false, error: action.payload };
    // }
    // case actions.ADD_CATEGORY_SUCCESS: {
    //   return {
    //     ...state,
    //     loading: false,
    //     error: "",
    //     categories: action.payload?.categories, // add new category to the list  of categories
    //   };
    // }

    default:
      return state;
  }
};

export default reducer;
